module.exports = __webpack_public_path__ + "static/media/Appentura_black.495811bc.svg";